<div
    role="alert"
    class="my-1"
    [ngClass]="getMessageIconsAndColor(message).color"
    *ngFor="let message of messages"
>
    <div class="d-flex">
        <mat-icon>{{ getMessageIconsAndColor(message).icon }}</mat-icon>
        <p class="ms-1">{{ message?.summary }}</p>
    </div>
    {{ message?.detail }}
    <div class="d-flex" *ngIf="message.footerTemplate">
        <ng-container [ngTemplateOutlet]="message.footerTemplate"></ng-container>
    </div>
</div>
